import { useTranslation } from 'react-i18next';

export const useTransLink = () => {
    const [url] = useTranslation('url');

    const generateTransPathname = (path: string) => {
        let to = path.split('/').reduce((result, c) => `${result}${url(c)}/`, '');
        to = to.substring(0, to.length - 1);
        return to;
    };

    return {
        generateTransPathname
    }
};